import { NO_ALCOHOL_STORES as DEFAULT_NO_ALCOHOL_STORES } from "@/utils/constant";
import { store } from "@/utils/redux/store";

export const getAlcoholStoreFilter = (
  storeID: string | undefined,
  storeRegion: string| undefined,
  brand?:string|null
) => {

  const state = store.getState();
  const dynamicNoAlcoholStores =
    state?.aemStaticSearchData?.resultsPage?.noAlcoholRegions || DEFAULT_NO_ALCOHOL_STORES;

  const isNoAlcoholStore = dynamicNoAlcoholStores.includes(storeRegion || "");

  const alcoholFilter = isNoAlcoholStore
    ? `storeId:${storeID} AND allergens.alcohol:false AND isVisible:true AND isMassOffers:false`
    : `storeId:${storeID} AND isVisible:true AND isMassOffers:false`;

    const filters = brand
    ? `${alcoholFilter} AND brand:"${brand}"`
    : alcoholFilter;

  return filters;
};

// export const getOptionalFilters = (
//   cartList: Record<string, any>
// ): string[] | undefined => {
//   const optionalFilters = cartList?.cartProducts?.products?.map(
//     (item: any) => `objectID:${item?.item_id}`
//   );
 
//   return optionalFilters;
// };


export const formatCategoryPartForURL = (str: string = ""): string => {

    return decodeURIComponent(str).replace(/\s+/g, "__");
};

export const formatCategoryForURL = (str: string = ""): string => {

  if (str?.includes("/products/category/"))
    return decodeURIComponent(str).replace(/\s+/g, "__");
  else return str;
};

export const decodeCategoryFromURL = (str: string = ""): string => {
  return decodeURIComponent(str).replace(/__/g, " ");
};

export const extractCategoryParts = (link: string = ""): string[] => {
  const parts = link.split("/category/")[1]?.split("/") || [];
  return parts;
};

export const formatDotProductSlug = (pageSlug: string = ""): string => {
  return encodeURIComponent(pageSlug?.replace(/\./g, '%2E'));
};
